<template>
  <div v-cloak>
    <div v-show="!successfullySubmitted">
      <div class="col-md-12 mb-4" style="text-align: center;">
        <div class="spacer-single"></div>
        <h5><p>Please provide the below information, and we will contact you with next steps:</p></h5>
      </div>
      <div class="row">
        <div class="form-group col-12 col-sm-6">
          <div class="row">
            <label class="col-12">
             Do you have an MDRT ID Number?  <span data-toggle="tooltip" title="If you are having trouble remembering your ID, please contact us at info@mdrt.org or use the chat box below."><i class="fa fa-info-circle" aria-hidden="true"></i></span>
            </label>
            <div class="col-12">
              <div class="form-check form-check-inline">
                <input class="form-check-input" v-bind:class="{ 'invalid-field': $v.hasMdrtID.$error }" type="radio" name="rdoHasMdrtID" id="rdoHasMdrtIDYes" value="true" v-model="hasMdrtID">
                <label class="form-check-label" for="rdoHasMdrtIDYes">Yes</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" v-bind:class="{ 'invalid-field': $v.hasMdrtID.$error }" type="radio" name="rdoHasMdrtID" id="rdoHasMdrtIDNo" value="false" v-model="hasMdrtID">
                <label class="form-check-label" for="rdoHasMdrtIDNo">No</label>
              </div>
              <div class="field-error-message" v-if="$v.hasMdrtID.$error && !$v.hasMdrtID.required">
                You must indicate if you have an MDRT ID.
              </div>
            </div>
          </div>
        </div>
        <div class="form-group col-12 col-sm-6">
          <div v-show="hasMdrtID == 'true'">
            <input type="text" class="form-control" v-bind:class="{ 'invalid-field': $v.mdrtID.$error }" name="txtMdrtID" placeholder="MDRT ID *" v-model="mdrtID" maxlength="9">
            <div class="field-error-message" v-if="$v.mdrtID.$error && !$v.mdrtID.required">
              MDRT ID is required.
            </div>
            <div class="field-error-message" v-if="$v.mdrtID.$error && !$v.mdrtID.integer">
              MDRT ID is invalid.
            </div>
            <div class="info-text">
              If you are having trouble remembering your ID, please contact us at <a href="mailto:info@mdrt.org"><strong style="color: #000;">info@mdrt.org</strong></a> or use the chat box below.
            </div>
          </div>
        </div>
      </div>
      <div name="memberJoinForm" id="memberJoinForm" v-show="hasMdrtID == 'true'">
        <div class="row">
          <div class="form-group col-12 col-sm-6">
            <input type="text" class="form-control" v-bind:class="{ 'invalid-field': $v.email.$error }" name="txtEmailMember" placeholder="Email *" v-model="email" maxlength="100">
            <div class="field-error-message" v-if="$v.email.$error && !$v.email.required">
              Email is required.
            </div>
            <div class="field-error-message" v-if="$v.email.$error && !$v.email.email">
              Email is invalid.
            </div>
          </div>
          <div class="form-group col-12 col-sm-6">
            <select class="form-control" v-bind:class="{ 'invalid-field': $v.role.$error }" v-model="role">
              <option value="" selected>Which best describes your role?</option>
              <option v-for="role in roleList" v-bind:value="role" v-bind:key="role">{{ role }}</option>
            </select>
            <div class="field-error-message" v-if="$v.role.$error && !$v.role.required">
              Role is required.
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-12">
            <button type="button" class="btn btn-primary" @click="submitJoinForm">Submit <i class="fa fa-arrow-right" v-show="!processingForm"></i><i class="fa fa-circle-o-notch fa-spin" v-show="processingForm"></i></button>
          </div>
        </div>
      </div>
      <div name="nonMemberJoinForm" id="nonMemberJoinForm" v-show="hasMdrtID == 'false'">
        <div class="row">
          <div class="form-group col-12 col-sm-6">
            <input type="text" class="form-control" name="txtFirstName" placeholder="First / Given Name" v-model="firstName" maxlength="20">
          </div>
          <div class="form-group col-12 col-sm-6">
            <input type="text" class="form-control" v-bind:class="{ 'invalid-field': $v.lastName.$error }" name="txtLastName" placeholder=" Last / Family / Surname *" v-model="lastName" maxlength="30">
            <div class="field-error-message" v-if="$v.lastName.$error && !$v.lastName.required">
              Last Name is required.
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-12 col-sm-6">
            <input type="text" class="form-control" v-bind:class="{ 'invalid-field': $v.email.$error }" name="txtEmailNonMember" placeholder="Email *" v-model="email" maxlength="100">
            <div class="field-error-message" v-if="$v.email.$error && !$v.email.required">
              Email is required.
            </div>
            <div class="field-error-message" v-if="$v.email.$error && !$v.email.email">
              Email is invalid.
            </div>
          </div>
          <div class="form-group col-12 col-sm-6">
            <select class="form-control" v-bind:class="{ 'invalid-field': $v.countryID.$error }" name="ddlCountry" v-model="countryID">
              <option value="">Country / Territory *</option>
              <option v-for="country in countryList" v-bind:value="country.ID" v-bind:key="country.ID">{{ country.Name }}</option>
            </select>
            <div class="field-error-message" v-if="$v.countryID.$error && !$v.countryID.required">
              Country is required.
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-12 col-sm-6">
            <input type="text" class="form-control" v-bind:class="{ 'invalid-field': $v.addressLine1.$error }" name="txtAddress1" placeholder="Address" v-model="addressLine1" maxlength="60">
            <div class="field-error-message" v-if="$v.addressLine1.$error && !$v.addressLine1.required">
              Address is required.
            </div>
          </div>
          <div class="form-group col-12 col-sm-6">
            <input type="text" class="form-control" name="txtAddress2" placeholder="Address Line 2" v-model="addressLine2" maxlength="60">
          </div>
        </div>
        <div class="row">
          <div class="form-group col-12 col-sm-6">
            <input type="text" class="form-control" v-bind:class="{ 'invalid-field': $v.city.$error }" name="txtCity" placeholder="City" v-model="city" maxlength="50">
            <div class="field-error-message" v-if="$v.city.$error && !$v.city.required">
              City is required.
            </div>
          </div>
          <div class="form-group col-12 col-sm-6">
            <select class="form-control" name="ddlState" v-bind:disabled="stateProvinceListByCountry.length == 0" v-model="stateProvinceID">
              <option value="">State / Province</option>
              <option v-for="stateProvince in stateProvinceListByCountry" v-bind:value="stateProvince.ID" v-bind:key="stateProvince.ID">{{ stateProvince.FullName }}</option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-12 col-sm-6">
            <input type="text" class="form-control" name="txtZipCode" placeholder="Postal Code" v-model="zipCode" maxlength="25">
          </div>
        </div>
        <div class="row">
          <div class="form-group col-12 col-sm-6">
            <select class="form-control" v-bind:class="{ 'invalid-field': $v.companyID.$error }" v-bind:disabled="companyListByCountry.length == 0" name="ddlCompany" v-model="companyID">
              <option value="">Company Name *</option>
              <option v-for="company in companyListByCountry" v-bind:value="company.ID" v-bind:key="company.ID">{{ company.Name }}</option>
            </select>
            <div class="field-error-message" v-if="$v.companyID.$error && !$v.companyID.required">
              Company Name is required.
            </div>
          </div>
          <div class="form-group col-12 col-sm-6">
            <input type="text" class="form-control" name="txtPersonalCompany" placeholder="Personal Company" v-model="personalCompanyName" maxlength="100">
          </div>
        </div>
        <div class="row">
          <div class="form-group col-12 col-sm-6">
            <select class="form-control" v-bind:class="{ 'invalid-field': $v.birthYear.$error }" name="ddlBirthYear" v-model="birthYear">
              <option value="">Birth Year *</option>
              <option v-for="year in birthYearList" v-bind:value="year" v-bind:key="year">{{ year }}</option>
            </select>
            <div class="field-error-message" v-if="$v.birthYear.$error && !$v.birthYear.required">
              Birth Year is required.
            </div>
          </div>
          <div class="form-group col-12 col-sm-6">
            <vue-tel-input name="txtCellPhone" class="form-control" v-bind:class="{ 'invalid-field': $v.cellPhone.$error }" placeholder="Mobile Phone" v-on:input="updateCellPhone" v-bind:validCharactersOnly="true"></vue-tel-input>
            <div class="field-error-message" v-if="$v.cellPhone.$error && !$v.cellPhone.isValidPhoneNumber">
              Cell Phone Number is invalid.
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-12 col-sm-6">
            <input type="text" class="form-control" name="txtTitle" placeholder="Title *" v-bind:class="{ 'invalid-field': $v.businessTitle.$error }" v-model="businessTitle" maxlength="50">
            <div class="field-error-message" v-if="$v.businessTitle.$error && !$v.businessTitle.required">
              Business Title is required.
            </div>
          </div>
          <div class="form-group col-12 col-sm-6">
            <vue-tel-input name="txtOfficePhone" class="form-control" v-bind:class="{ 'invalid-field': $v.phone.$error }" placeholder="Office Phone *" v-on:input="updatePhone" v-bind:validCharactersOnly="true"></vue-tel-input>
            <div class="field-error-message" v-if="$v.phone.$error && !$v.phone.number.required">
              Office Phone Number is required.
            </div>
            <div class="field-error-message" v-if="$v.phone.$error && !$v.phone.isValidPhoneNumber">
              Office Phone Number is invalid.
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-12 col-sm-6">
            <select class="form-control" v-bind:class="{ 'invalid-field': $v.role.$error }" v-model="role">
              <option value="" selected>Which best describes your role? *</option>
              <option v-for="role in roleList" v-bind:value="role" v-bind:key="role">{{ role }}</option>
            </select>
            <div class="field-error-message" v-if="$v.role.$error && !$v.role.required">
              Role is required.
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-12">
            <button type="button" class="btn btn-primary" @click="submitJoinForm" :disabled="processingForm">Submit <i class="fa fa-arrow-right" v-show="!processingForm"></i><i class="fa fa-circle-o-notch fa-spin" v-show="processingForm"></i></button>
          </div>
        </div>
      </div>
    </div>
    <div v-show="successfullySubmitted">
      <h4>
        Submission confirmation! Thank you for your interest and submitting your request to join 
        MDRT Global Services. The MDRT Global Services team will be in touch on next steps once 
        the pilot program officially begins in January 2021.
      </h4>
    </div>
  </div>
</template>

<script>

  import { required, requiredIf, email, integer } from 'vuelidate/lib/validators';
  import axios from 'axios';

  var _collection = require('lodash/collection');

  var gsWebServiceUrl = 'https://my.mdrt.org/WebServices/GlobalSvcsSiteService__mdrt.asmx'

  // Validator to check a phone number is valid.
  const isValidPhoneNumber = function(value) {
    // Blank is allowed; required validator will handle that.
    return value.number == '' || value.isValid;
  }

  export default {
    name: 'joinFormApp',
    data () {
      return {
        firstName: '',
        lastName: '',
        email: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        stateProvinceID: '',
        zipCode: '',
        countryID: '',
        companyID: '',
        personalCompanyName: '',
        birthYear: '',
        cellPhone: {
          countryCode: '',
          areaCode: '',
          number: '',
          isValid: false
        },
        businessTitle: '',
        phone: {
          countryCode: '',
          areaCode: '',
          number: '',
          isValid: false
        },
        preferredLanguage: '',
        role: '',
        hasMdrtID: '',
        mdrtID: '',
        countryList: null,
        stateProvinceList: null,
        companyList: null,
        birthYearList: null,
        roleList: null,
        successfullySubmitted: false,
        processingForm: false
      }
    },
    computed: {
      companyListByCountry: function() {

        // Return empty array if there is no country selected.
        if (this.countryID == '') {
          return [];
        }

        // Select the company options by country.
        return _collection.filter(this.companyList, ['CountryID', this.countryID]);

      },
      stateProvinceListByCountry: function() {

        // Return empty array if there is no country selected.
        if (this.countryID == '') {
          return [];
        }

        // Select the state/province options by country.
        return _collection.filter(this.stateProvinceList, ['CountryID', this.countryID]);

      }
    },
    watch: {
      countryID: function () {

        // Country changed, set the company and state/province to empty.
        this.companyID = '';
        this.stateProvinceID = '';
      }
    },
    async created() {

      // Populate the year drop-down
      this.birthYearList = new Array();
      var currentYear = new Date().getFullYear();
      for(var i = currentYear - 18; i >= currentYear-118; i--) {
        this.birthYearList.push(i);
      }

      // Populate the role dropdown.
      this.roleList = [
        'Sales Manager',
        'General Agent/Agency Manager/Managing Partner',
        'Unit Supervisor',
        'Regional VP',
        'District Manager',
        'Assistant Agency Head',
        'Home Office Executive'
      ];

      // Populate all the drop downs that use service data.
      try {

        let countryRes = await axios.post(gsWebServiceUrl + '/GetCountries', {});
        this.countryList = countryRes.data.d;

        let stateProvinceRes = await axios.post(gsWebServiceUrl + '/GetStatesProvinces', {});
        this.stateProvinceList = stateProvinceRes.data.d;

        let companyRes = await axios.post(gsWebServiceUrl + '/GetAffiliatedCompanies', {});
        this.companyList = companyRes.data.d;

      } catch(err) {
        console.log(err);
        alert("An error occurred loading the form.");
      }
    },
    validations: {
      lastName: {
        required
      },
      email: {
        required,
        email
      },
      countryID: {
        required
      },
      addressLine1: {
        required
      },
      city: {
        required
      },
      companyID: {
        required: requiredIf(function() {
          return this.companyListByCountry.length > 0;
        })
      },
      birthYear: {
        required
      },
      businessTitle: {
        required
      },
      cellPhone: {
        isValidPhoneNumber
      },
      phone: {
        number: {
          required
        },
        isValidPhoneNumber
      },
      hasMdrtID: {
        required
      },
      mdrtID: {
        required: requiredIf(function() {
          return this.hasMdrtID == 'true';
        }),
        integer
      },
      role: {
        required
      },
      memberFormVG: ['mdrtID',
                     'email',
                     'role'],
      nonMemberFormVG: ['lastName',
                        'email',
                        'countryID',
                        'addressLine1',
                        'city',
                        'companyID',
                        'birthYear',
                        'businessTitle',
                        'cellPhone',
                        'phone',
                        'role']
    },
    methods: {                    
      submitJoinForm: async function () {

        var currentValGroup;

        // Choose validation group based on whether they have an MDRTID or not.
        if(this.hasMdrtID == 'true') {
          currentValGroup = this.$v.memberFormVG;
        } else {
          currentValGroup = this.$v.nonMemberFormVG;
        }

        // Check validation
        currentValGroup.$touch();

        if (currentValGroup.$anyError) {
          return;
        }

        try {

          this.processingForm = true;

          let res = await axios.post(gsWebServiceUrl + '/SubmitJoinForm',
          {
            firstName: this.firstName,
            lastName: this.lastName,
            email: this.email,
            addressLine1: this.addressLine1,
            addressLine2: this.addressLine2,
            city: this.city,
            stateProvinceID: this.stateProvinceID != '' ? parseInt(this.stateProvinceID) : 0,
            zipCode: this.zipCode,
            countryID: this.countryID != '' ?  parseInt(this.countryID) : 0,
            companyID: this.companyID != '' ?  parseInt(this.companyID) : 0,
            personalCompanyName: this.personalCompanyName,
            birthYear: this.birthYear != '' ? parseInt(this.birthYear) : 0,
            businessTitle: this.businessTitle,
            cellCountryCode: this.cellPhone.countryCode,
            cellAreaCode: this.cellPhone.areaCode,
            cellPhone: this.cellPhone.number,
            phoneCountryCode: this.phone.countryCode,
            phoneAreaCode: this.phone.areaCode,
            phone: this.phone.number,
            preferredLanguage: this.preferredLanguage,
            role: this.role,
            hasMdrtID: (this.hasMdrtID == 'true'),
            mdrtID: this.mdrtID !='' ? parseInt(this.mdrtID) : 0
          });
          if(res.data.d) {
            this.successfullySubmitted = true;
          }
        } catch(err) {
          console.log(err);
        } finally {
          this.processingForm = false;
        }
      },
      updateCellPhone: function(number, data) {
        this.parsePhoneInputData(this.cellPhone, number, data);
      },
      updatePhone: function(number, data) {
        this.parsePhoneInputData(this.phone, number, data);
      },
      parsePhoneInputData(targetPhone, inputNumber, inputData) {
        targetPhone.isValid = inputData.isValid;
        targetPhone.countryCode = inputData.country.dialCode

        // Break out the area code if this is a valid US or Canada phone number, 
        // otherwise, just dump it into the phone field
        if (inputData.isValid && inputData.country.dialCode == 1) {
          var splitNum = inputNumber.split(' ')
          targetPhone.areaCode = splitNum[0].substring(1,4);
          targetPhone.number = splitNum[1];
        } else {
          targetPhone.areaCode = '';
          targetPhone.number = inputNumber;
        }
      }
    }
  }
</script>

<style>
  /* Vue Styles */
  [v-cloak] > * { display:none }
  [v-cloak]::before { content: "loading…" }

  .info-text {
    font-size: 0.75em;
  }

  /* Error styles */
  .error-asterisk {
    color: red;
  }

  .field-error-message {
    color: red;
    font-size: 0.75em;
  }

  .field-valid-message {
    color: green;
    font-size: 0.75em;
  }

  .invalid-field {
    border-color: red;
    box-shadow: 0px 0px 10px red;
    background-color: #ffdbdb;
  }

  .vue-tel-input.invalid-field {
    border-color: red;
    box-shadow: 0px 0px 10px red;
    background-color: #ffdbdb;
  }

  .vue-tel-input.invalid-field .vti__input {
    background-color: #ffdbdb;
  }

  .form-control:disabled {
    color: #cccccc;
    border-color: #e6e6e6;
    background-color: #f2f2f2;
  }
</style>